import gql from 'graphql-tag';

export default gql`
  mutation SynchronizeCompanyRoomList {
    synchronizeCompanyRoomList {
      errors
    }
  }
`;
